import { useEffect, useState } from "react";
import { Autocomplete, TextField, Tooltip } from "components/mui";
import { MST_CUST_ID, ACCESS_OPTIONS } from "containers/pages/users/constants";
import { funcType, userType, validType } from "containers/pages/users/types";

/**
 * @component AccessSelector
 * @param {Object} props
 * @param {User} props.user
 * @param {UserValid} props.valid
 * @param {function} props.handleForm
 * @returns {JSX.Element}
 */
function AccessSelector({ user, valid, handleForm }) {
  const [isDisabled, setIsDisabled] = useState(true);

  const onChange = (e, newValues) => {
    e.target.name = MST_CUST_ID;
    handleForm(e, newValues);
  };

  useEffect(() => {
    if (user.companies.length > 0) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [user.companies.length]);

  return (
    <Autocomplete
      value={user[MST_CUST_ID]}
      options={user[ACCESS_OPTIONS]}
      disabled={isDisabled}
      getOptionLabel={(option) => (option.Name ? option.Name : "")}
      onChange={onChange}
      renderInput={(params) => (
        <Tooltip title="Specify which company's data this user has access to." arrow>
          <TextField
            {...params}
            variant="outlined"
            label="Accessible Data"
            required
            InputLabelProps={{ shrink: true }}
            error={valid[MST_CUST_ID].isErr}
            helperText={valid[MST_CUST_ID].errMsg}
          />
        </Tooltip>
      )}
    />
  );
}

AccessSelector.propsType = {
  user: userType,
  valid: validType,
  handleForm: funcType,
};

export default AccessSelector;
